<!-- src/routes/Home.svelte -->
<script>
    import { push } from 'svelte-spa-router'; 

    const logoSrc = '/logo.png';

    let container;
    
    function startAdventure() {
        container.style.transition = 'opacity 1s';
        container.style.opacity = 0;
        setTimeout(() => {
            push('/adventure'); 
        }, 1000); 
    }
</script>

<div bind:this={container} class="center-container">
    <img src={logoSrc} alt="Logo" class="logo">
    <h1 class="battle-text">THE BATTLE FOR EARTH</h1>
    <p><button class="start-button" on:click={startAdventure} aria-label="Press Start">PRESS START</button></p>
    <p>165 CHOICES TO MAKE</p>
</div>

<style>
   .center-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100vh; 
        text-align: center; 
        padding: 0 20px; /* Add padding to prevent content from touching the edges */
    }
    .start-button {
        display: block;
        margin: 50px auto;
        padding: 1em 2em; /* Default padding for smaller screens */
        font-size: 1.5em; /* Default font size for smaller screens */
        cursor: pointer;
        border: 2px solid transparent;
        background-color: #007bff;
        color: #fff;
        border-radius: 10px;
        animation: flash-border .8s infinite;
        transition: background-color 0.3s, border-color 0.3s; /* Smooth transition for hover state */
    }
    @keyframes flash-border {
        0% {
            border-color: transparent;
        }
        50% {
            border-color: #fff;
        }
        100% {
            border-color: transparent;
        }
    }
    .start-button:hover {
        background-color: #0056b3; 
    }
    .logo {
        max-width: 80%; /* Use percentage for max-width */
        height: auto;
        margin-bottom: 20px; 
        animation: scaleAnimation 30s infinite;
    }
    .battle-text {
        text-align: center;
        font-size: 2em; /* Default font size */
        margin: 20px 0;
        color: rgb(0, 0, 0);
        animation: scale 10s infinite, colorChange .8s infinite;
    }
    @media (min-width: 768px) {
        .battle-text {
            font-size: 3em; /* Larger font size for larger screens */
        }

        .start-button {
            padding: 1.5em 3em; /* Larger padding for larger screens */
            font-size: 2em; /* Larger font size for larger screens */
        }
    }

    @keyframes scale {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.2); }
    }

    @keyframes colorChange {
        0% { color: #ff6060; }
        25% { color: #000000; }
        50% { color: #8b2929; }
        75% { color: #000000; }
        100% { color: #ff6060; }
    }
</style>